import { useSelector } from 'react-redux'

import { AuthLayout } from '../../components/AuthLayout'
import { ChangeLog } from '../../components/ChangeLog'
import { NoneMessage } from '../../components/NoneMessage'
import { PageBody } from '../../components/PageBody'
import { PageLabel } from '../../components/PageLabel'
import { PaginationContainer } from '../../components/PaginationContainer'
import { Spacer } from '../../components/Spacer'
import { TabContainer } from '../../components/TabContainer'
import { useChangeLog } from '../../hooks/useChangeLog'
import { selectCompanyMemberDirectory } from '../../store/company'
import { isEqual } from '../../util/isEqual'

export function Audits(): JSX.Element {
  const {
    data,
    isLoading: changelogIsLoading,
    page,
    pageSize,
    totalItems,
    setPage,
  } = useChangeLog()
  const companyMembers = useSelector(selectCompanyMemberDirectory, isEqual)
  const isLoading = changelogIsLoading || !companyMembers
  return (
    <AuthLayout>
      <PageBody>
        <PageLabel title="Audits" description="Gate asset observation data audit log." />
        <Spacer vertical size={4} />
        <TabContainer
          activeKey="log"
          tabs={[
            {
              title: 'Log',
              key: 'log',
              Component: (
                <>
                  <Spacer vertical size={2} />
                  {!isLoading && data.length === 0 ? (
                    <NoneMessage message="No Events" />
                  ) : (
                    <PaginationContainer
                      currentPage={page}
                      pageSize={pageSize}
                      totalItems={totalItems}
                      onPageSelect={setPage}
                      disabled={isLoading}
                    >
                      <ChangeLog
                        isLoading={isLoading}
                        data={data || []}
                        companyMembers={companyMembers || {}}
                      />
                    </PaginationContainer>
                  )}
                </>
              ),
            },
          ]}
        />
      </PageBody>
    </AuthLayout>
  )
}
